'use client';
import React from 'react';
import {
  ResponsiveContainer, ComposedChart, Area, Line, Bar,
  XAxis, YAxis, CartesianGrid, Tooltip, Legend, defs, linearGradient, stop,
} from 'recharts';
import { LSD_TREND_DATA } from './analyticsData';

const CustomTooltip = ({ active, payload, label }: any) => {
  if (!active || !payload?.length) return null;
  return (
    <div className="bg-white rounded-xl border shadow-elevated p-3 text-xs" style={{ borderColor: 'hsl(var(--border))' }}>
      <p className="font-semibold mb-2">{label}</p>
      {payload.map((p: any) => (
        <div key={`tt-${p.dataKey}`} className="flex items-center gap-2 mb-1">
          <div className="w-2 h-2 rounded-full flex-shrink-0" style={{ background: p.color }} />
          <span className="text-muted">{p.name}:</span>
          <span className="font-semibold tabular-nums">{p.value}{p.dataKey === 'avgLsd' ? '' : ''}</span>
        </div>
      ))}
    </div>
  );
};

export default function LsdTrendChart() {
  return (
    <ResponsiveContainer width="100%" height={240}>
      <ComposedChart data={LSD_TREND_DATA} margin={{ top: 4, right: 4, left: -16, bottom: 0 }}>
        <defs>
          <linearGradient id="lsdGrad" x1="0" y1="0" x2="0" y2="1">
            <stop offset="5%" stopColor="hsl(218, 70%, 22%)" stopOpacity={0.15} />
            <stop offset="95%" stopColor="hsl(218, 70%, 22%)" stopOpacity={0} />
          </linearGradient>
          <linearGradient id="critGrad" x1="0" y1="0" x2="0" y2="1">
            <stop offset="5%" stopColor="hsl(355, 75%, 58%)" stopOpacity={0.2} />
            <stop offset="95%" stopColor="hsl(355, 75%, 58%)" stopOpacity={0} />
          </linearGradient>
        </defs>
        <CartesianGrid stroke="hsl(214, 20%, 88%)" strokeDasharray="3 3" vertical={false} />
        <XAxis dataKey="month" tick={{ fontSize: 11, fill: 'hsl(215, 15%, 50%)' }} axisLine={false} tickLine={false} />
        <YAxis yAxisId="lsd" tick={{ fontSize: 11, fill: 'hsl(215, 15%, 50%)' }} axisLine={false} tickLine={false} domain={[20, 70]} />
        <YAxis yAxisId="count" orientation="right" tick={{ fontSize: 11, fill: 'hsl(215, 15%, 50%)' }} axisLine={false} tickLine={false} />
        <Tooltip content={<CustomTooltip />} />
        <Legend wrapperStyle={{ fontSize: 11, paddingTop: 8 }} />
        <Bar yAxisId="count" dataKey="inspections" name="Inspections" fill="hsl(218, 70%, 22%)" opacity={0.12} radius={[2, 2, 0, 0]} />
        <Area yAxisId="lsd" type="monotone" dataKey="avgLsd" name="Avg LSD Score" stroke="hsl(218, 70%, 22%)" strokeWidth={2.5} fill="url(#lsdGrad)" dot={false} activeDot={{ r: 4, fill: 'hsl(218, 70%, 22%)' }} />
        <Line yAxisId="lsd" type="monotone" dataKey="critical" name="Critical Findings" stroke="hsl(355, 75%, 58%)" strokeWidth={2} dot={false} strokeDasharray="4 3" activeDot={{ r: 4 }} />
      </ComposedChart>
    </ResponsiveContainer>
  );
}